// src/components/module/ventas/facturas/PDFQRCode.tsx
import React from 'react';
import { View, Image } from '@react-pdf/renderer';
import QRCode from 'qrcode';

interface PDFQRCodeProps {
  value: string;
  size?: number;
}

export const PDFQRCode: React.FC<PDFQRCodeProps> = ({ value, size = 100 }) => {
  const [qrUrl, setQrUrl] = React.useState<string | null>(null);

  React.useEffect(() => {
    QRCode.toDataURL(value)
      .then((url: string) => {
        setQrUrl(url);
      })
      .catch((err: unknown) => {
        console.error('Error generando QR:', err);
      });
  }, [value]);

  return (
    <View>
      {qrUrl ? <Image src={qrUrl} style={{ width: size, height: size }} /> : null}
    </View>
  );
};